import { render, staticRenderFns } from "./KnowHowDetail.vue?vue&type=template&id=066cac66&"
import script from "./KnowHowDetail.vue?vue&type=script&lang=js&"
export * from "./KnowHowDetail.vue?vue&type=script&lang=js&"
import style0 from "./KnowHowDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports